import { allAccountsActions, allAccountsReducers, allAccountsDialogsReducers } from '@frontegg/redux-store';
import { reducerActionsGenerator, stateHookGenerator } from '../hooks';
const defaultMapper = state => state;
export function useAllAccountsState(stateMapper = defaultMapper) {
  return stateHookGenerator(stateMapper, 'allAccountsState');
}
export const useAllAccountsActions = () => reducerActionsGenerator(allAccountsActions, allAccountsReducers);

//dialogs

const defaultDialogsMapper = state => state;
export function useAllAccountsDialogsState(stateMapper = defaultDialogsMapper) {
  return stateHookGenerator(stateMapper, 'allAccountsDialogsState');
}
export const useAllAccountsDialogsActions = () => reducerActionsGenerator({}, allAccountsDialogsReducers);